<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { mdiAccount, mdiBookSearch, mdiClose, mdiDomain } from "@mdi/js"
    import Icon from "../../widgets/Icon.svelte"
    import { _ } from "lodash"
    import { _ as _i18n } from "svelte-i18n"
    import { getAddresses } from "../../../api"
    import { getFilterForAddressSearch } from "../../../helper"
    import Select from "svelte-select"

    export let reset: boolean = false
    export let headline: string = null
    export let headlineAsLabel: boolean = false
    export let filter: any = null
    export let hideEmptyState: boolean = true
    export let focused: boolean = false
    export let currentSelect: string | null | undefined = null

    const dispatch = createEventDispatcher()
    let addresses: Address[] = []
    let value: { value: any; label?: string } | null | undefined

    let allAddresses: Address[]
    const buildLabel = (item: any, parentCompany: any) => {
        if (item.type === "person") {
            return ` ${
                item?.deliveryAddress?.name3 || item?.person?.lastname + " " + item?.person?.firstname || ""
            } - ${parentCompany?.deliveryAddress?.name1 || parentCompany?.company?.name || ""} ${
                item.customerNumber
                    ? `- ${$_i18n("address.customerNumberLabel", { values: { customerNumber: item.customerNumber } })}`
                    : ""
            } - ${$_i18n("address.dealerNumberLabel", { values: { dealerNumber: item?.dealerNumber } })}`
        } else {
            return ` ${item?.deliveryAddress?.name1 || item?.company?.name || ""} ${
                item.customerNumber
                    ? `- ${$_i18n("address.customerNumberLabel", { values: { customerNumber: item.customerNumber } })}`
                    : ""
            } - ${$_i18n("address.dealerNumberLabel", { values: { dealerNumber: item?.dealerNumber } })}`
        }
    }

    const searchAddresses = async (search: string) => {
        let _filter = getFilterForAddressSearch(search)
        if (filter) {
            _filter = { $and: [filter, _filter] }
        }

        if (!allAddresses) {
            const initResponse = await getAddresses(null, null, null, null, null, true, "", true)
            if (initResponse) {
                allAddresses = initResponse.data
            }
        }

        const response = await getAddresses(_filter, null, 0, null, "-type", true, "", true)
        if (!response) {
            return []
        }

        const { data } = response
        addresses = data

        const selected = data.find((a) => a.id === currentSelect)
        value = {
            value: selected ? selected.id : null,
            label: selected
                ? buildLabel(
                      selected,
                      allAddresses.find((a) => a?.id === selected?.person?.parentCompany)
                  )
                : $_i18n("address.manualEntry"),
        }

        const values = data.reduce((acc, c) => {
            const parentCompany = allAddresses.find((a) => a?.id === c?.person?.parentCompany)
            if (!(c.type === "person" && !parentCompany)) {
                acc.push({
                    value: c.id,
                    label: buildLabel(c, parentCompany),
                })
            }
            return acc
        }, [])

        return values
    }

    $: {
        searchAddresses("")
    }

    const onChange = (e: CustomEvent) => {
        dispatch("reset")
        let address = addresses.filter((address) => address?.id === e?.detail?.value)[0]
        if (!address) dispatch("clear")
        else dispatch("selected", JSON.parse(JSON.stringify(address)))
    }

    const onClear = (e: CustomEvent) => {
        value = {
            value: null,
            label: $_i18n("address.manualEntry"),
        }
        dispatch("clear")
    }

    $: if (reset) {
        addresses = []
        value = null
    }
    let initial = true
    $: if (initial && value) {
        initial = false
        if (value?.value) {
            dispatch("selected", addresses?.filter((address) => address?.id === value?.value)[0])
        }
    }
    $: if (value == undefined) {
        value = {
            value: null,
            label: $_i18n("address.manualEntry"),
        }
    }
</script>

<section class="address-search">
    {#if !headlineAsLabel && headline}
        <div class="section-title sm">{headline}</div>
    {/if}
    <div class="row">
        <div class="col-md-12">
            <div class="inputholder" class:haslabel="{headlineAsLabel}" class:hasNoValue="{!value?.value}">
                {#if headlineAsLabel && headline}
                    <label for="">{headline}</label>
                {/if}

                <Select
                    inputAttributes="{{ autocomplete: 'off' }}"
                    placeholder=""
                    showChevron="{true}"
                    {focused}
                    clearable="{!!value?.value}"
                    {hideEmptyState}
                    loadOptions="{searchAddresses}"
                    bind:value
                    on:change="{onChange}"
                    on:clear="{onClear}"
                >
                    <div slot="clear-icon">
                        {#if value?.value}
                            <Icon path="{mdiClose}" size="24px" />
                        {/if}
                    </div>
                    <div slot="chevron-icon">
                        <Icon path="{mdiBookSearch}" size="24px" />
                    </div>
                    <div slot="item" let:item style="display: flex; align-items: center;">
                        {#if allAddresses?.find((a) => a?.id == item?.value)?.type == "company"}
                            <Icon path="{mdiDomain}" size="24px" />
                        {:else}
                            <Icon path="{mdiAccount}" size="24px" />{/if}
                        <span style="margin-left: 10px;"> {item?.label}</span>
                    </div>
                    <div slot="prepend" style="margin-right: 10px; display: flex; align-items: center;">
                        <Icon
                            path="{allAddresses?.find((a) => a?.id == value?.value)?.type === 'person'
                                ? mdiAccount
                                : mdiDomain}"
                            size="24px"
                        />
                    </div>
                </Select>
            </div>
        </div>
    </div>
</section>
